// extracted by mini-css-extract-plugin
export default {"gridWrapper":"PhotoGallery_gridWrapper__0DoDA","column":"PhotoGallery_column__aYtba","loadingContainer":"PhotoGallery_loadingContainer__xNfmg"};